module.exports = __webpack_public_path__ + "img/student2.70a468ed.png";